/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![VideoLockIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABCklEQVR4nGNgGAWDAoSGhrL5BYR3+vqHP/MLiPhPLPYNCH/qFxDRAdKP1wKQIlIM9sPEHXgtgLqEbAt8A8KfIpvn7x9u5RMYZoTsg/+UYgaQOX5hjr4BEQchYuEfqWqBn3/EKmyWUs+CAOy+GrXgP82DyDcg4qhvYIRHaGgoDwiD2H7+4Yf9AiJuU2yBb0D4ant7exaCRQVZhvtHfPDwiOaD6A/PBxUzEByRSw0LfvgFhkVAc60tNB9s9vUP3+IXEPHPJyDShsKiIjwfoTeiEiTm4eHBDsLQeKmkqLALDQ0Vghp+FHfODj+MVlxHdBDjE1//8DfEBi3ByKc0cYxawADNsbhy+CFQEAEAepiZV/s/oTMAAAAASUVORK5CYII=)
 */
export const VideoLockIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M4 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h8.5a.5.5 0 0 0 .5-.5V19a3 3 0 0 1 1.46-2.58.6.6 0 0 0 .26-.32 4.5 4.5 0 0 1 6.96-2.22c.42.32 1.32.02 1.32-.5V7.62a1 1 0 0 0-1.45-.9l-3 1.5a1 1 0 0 0-.55.9V7a3 3 0 0 0-3-3H4Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M16 18h.5v-.5a2.5 2.5 0 0 1 5 0v.5h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1Zm4-.5v.5h-2v-.5a1 1 0 1 1 2 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
